export default {
  tryAgain: {
    id: 'asp_action_bar_actions_list_step_try_again_action',
    defaultMessage: 'Try again',
  },
  errorTitle: {
    id: 'asp_action_bar_actions_list_step_error_title',
    defaultMessage: 'Damn robots!',
  },
  errorContent: {
    id: 'asp_action_bar_actions_list_step_error_content',
    defaultMessage:
      'Our server is a bit slow at the moment. Please give it a sec and try again.',
  },
}
